import { render, staticRenderFns } from "./robotBatchSetup.vue?vue&type=template&id=41a4eacc&scoped=true&"
import script from "./robotBatchSetup.vue?vue&type=script&lang=js&"
export * from "./robotBatchSetup.vue?vue&type=script&lang=js&"
import style0 from "./robotBatchSetup.vue?vue&type=style&index=0&id=41a4eacc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a4eacc",
  null
  
)

export default component.exports